export default __webpack_public_path__ + "static/media/SV.1cb834d0.svg";